import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/twitter_blue.svg'


const _withScopeId = n => (_pushScopeId("data-v-071d889f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h5 q-mt-sm" }
const _hoisted_2 = { class: "q-pt-md" }
const _hoisted_3 = { class: "text-h4 q-mt-sm" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "q-pa-md" }


import IconLink from '../utils/IconLink.vue';
interface Props {
  imgPath: string
  name: string
  twitterName: string
  text: string[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MemberList',
  props: {
    imgPath: null,
    name: null,
    twitterName: null,
    text: null
  },
  setup(__props: any) {

const prop = __props as {
  imgPath: string
  name: string
  twitterName: string
  text: string[]
};



function loadAvatar() {
  return require(`@/assets/Home/${prop.imgPath}`)
}

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_item, { class: "desktop-only q-py-lg" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { side: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_avatar, {
              square: "",
              size: "180px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_img, {
                  src: loadAvatar(),
                  class: "avater-img"
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(__props.name), 1),
            _createVNode(IconLink, {
              href: `https://twitter.com/${__props.twitterName}`,
              icon: "Twitter"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" @" + _toDisplayString(__props.twitterName), 1)
              ]),
              _: 1
            }, 8, ["href"]),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.text, (line) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: line,
                  style: {"width":"100%"}
                }, _toDisplayString(line), 1))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_expansion_item, {
      class: "mobile-only",
      style: {"width":"80vw"}
    }, {
      header: _withCtx(() => [
        _createVNode(_component_q_item_section, { side: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_avatar, {
              square: "",
              size: "120px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_img, {
                  src: loadAvatar(),
                  class: "avater-img"
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.name), 1),
            _createElementVNode("a", {
              href: `https://twitter.com/${__props.twitterName}`,
              target: "_blank",
              class: "text-h5 q-pa-none",
              style: {"width":"max-content"}
            }, [
              _createVNode(_component_q_img, {
                src: _imports_0,
                width: "1.6rem"
              }),
              _createTextVNode("@" + _toDisplayString(__props.twitterName), 1)
            ], 8, _hoisted_4)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.text, (line) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: line,
                  style: {"width":"100%"}
                }, _toDisplayString(line), 1))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})